import type { IngestedEventSample } from '@vy/types';
import React from 'react';
import { VyTable } from '../../../../../components/new-design/table/vy-table/VyTable';
import type { VyTableMinimalProps } from '../../../../../components/new-design/table/vy-table/vy-table-types';
import { EVENTS_TABLE_COLUMNS } from './events-table-consts/events-columns';

type EventsTableProps = Omit<VyTableMinimalProps<IngestedEventSample>, 'tableName'>;

export const EventsTable: React.FC<EventsTableProps> = ({
  items,
  itemsCount,
  loadingItems,
  ...props
}) => {
  return (
    <VyTable
      tableName="events"
      itemsCount={itemsCount}
      items={items}
      columns={EVENTS_TABLE_COLUMNS}
      loading={loadingItems}
      getRowId={(row) => row.ref}
      {...props}
      sx={{
        ...props.sx,
      }}
    />
  );
};
